import { useState, useCallback } from 'react';
import { useApi, identityApiRef } from '@backstage/core-plugin-api';

export const useUserIdentity = () => {
  const identityApi = useApi(identityApiRef);
  const [userEmail, setUserEmail] = useState<string>('');
  const [userName, setUserName] = useState<string>('');

  const fetchUserIdentity = useCallback(async (): Promise<{ email: string; userName: string; token: string }> => {
    const identity = await identityApi.getBackstageIdentity();
    const credentials = await identityApi.getCredentials();

    if (!credentials.token) {
      throw new Error('No authentication token available');
    }

    const decoded = JSON.parse(atob(credentials.token.split('.')[1])) as {
      originalEmail?: string;
      email?: string;
      displayName?: string;
    };

    const email = decoded.originalEmail || decoded.email || identity.userEntityRef;
    setUserEmail(email);
    setUserName(decoded.displayName || email);

    if (!email) {
      throw new Error('Email not found in token or identity');
    }

    return { email, userName: decoded.displayName || email, token: credentials.token };
  }, [identityApi]);

  return { userEmail, userName, fetchUserIdentity };
};
